import { useQuery } from 'react-query';
import http from '@framework/utils/http';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
interface NewsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Post[];
}
export interface Post {
  id: number;
  title: string;
  image: string | null;
  summary: string;
  publicationDate: string;
}
export const fetchNews = async (): Promise<NewsResponse> => {
  const {
    data
  } = await http.get(`${API_ENDPOINTS.NEWS}`);
  return data;
};
export const useNewsQuery = () => {
  return useQuery<NewsResponse, Error>([API_ENDPOINTS.NEWS], fetchNews, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};
export const fetchNewsById = async (id: number): Promise<Post> => {
  const {
    data
  } = await http.get(`${API_ENDPOINTS.NEWS_CONTENT}${id}`);
  return data;
};
export const useNewsByIdQuery = (id: number) => {
  return useQuery<Post, Error>([API_ENDPOINTS.NEWS_CONTENT, id], () => fetchNewsById(id), {
    enabled: !!id,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });
};